module.exports = __webpack_public_path__ + "static/headshot-ted-reed-3x.417c663c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ted-reed-3x.jpg
// module id = 142
// module chunks = 35783957827783 152909308826437